import React from "react";
import { Skeleton } from "@mui/material";
import "./CourseCardSkeleton.scss";

/**
 * Skeleton loader para un card de curso.
 *
 * @param className - Clases CSS adicionales.
 * @param {Object} props - Props del componente.
 * @param {"default" | "completed" | "progress"} props.variant - Variante visual del skeleton.
 */
export const CourseCardSkeleton = ({
  className = "",
  variant = "default",
  ...props
}) => {
  const cardClasses = ["course-card-skeleton", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cardClasses} {...props}>
      <Skeleton
        variant="rectangular"
        className="course-card-skeleton__image"
        animation="wave"
      />

      <div className="course-card-skeleton__separator" />

      <div className="course-card-skeleton__content">
        <Skeleton
          variant="rounded"
          width="60%"
          height={24}
          animation="wave"
          className="course-card-skeleton__badge"
        />

        <div className="course-card-skeleton__title">
          <Skeleton variant="text" width="90%" height={18} animation="wave" />
          <Skeleton variant="text" width="70%" height={18} animation="wave" />
        </div>

        {variant === "default" && (
          <div className="course-card-skeleton__subtitle">
            <Skeleton variant="text" width="25%" height={16} animation="wave" />
            <Skeleton variant="text" width="30%" height={16} animation="wave" />
            <Skeleton variant="text" width="20%" height={16} animation="wave" />
          </div>
        )}

        {variant === "progress" && (
          <div className="course-card-skeleton__progress">
            <Skeleton variant="text" width="60%" height={16} animation="wave" />
            <Skeleton
              variant="text"
              width="100%"
              height={20}
              animation="wave"
            />
          </div>
        )}

        {variant === "completed" && (
          <div className="course-card-skeleton__completed">
            <Skeleton
              variant="rounded"
              width="100%"
              height={36}
              style={{ borderRadius: 8 }}
              animation="wave"
            />
            <Skeleton
              variant="rounded"
              width="100%"
              height={36}
              style={{ borderRadius: 8 }}
              animation="wave"
            />
          </div>
        )}
      </div>
    </div>
  );
};
